import React from "react";
import { Card, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "./header";
import Footer from "./footer";
import { useNavigate } from "react-router-dom";

export default function MernStackJobs() {
  const navigate = useNavigate();

  const handleApplyNow = (job) => {
    navigate(`/job-details/${job.id}`, { state: { job } });
  };

  const jobOpenings = [
    {
      id: "mern-001",
      title: "MERN Stack Developer",
      company: "Techlight",
      location: "India, Remote",
      salary: "₹12L - ₹25L",
      description:
        "Techlight is seeking a MERN Stack Developer to work on cutting-edge web applications using MongoDB, Express.js, React.js, and Node.js. Collaborate with a highly skilled team to build scalable applications and solve complex technical challenges.",
    },
    {
      id: "mern-002",
      title: "Senior MERN Stack Engineer",
      company: "InnoTechies",
      location: "India, Remote",
      salary: "₹15L - ₹30L",
      description:
        "Join InnoTechies as a Senior MERN Stack Engineer, leading development efforts for high-performance web platforms. You'll work closely with cross-functional teams to deliver clean, efficient code across the full stack (MongoDB, Express.js, React.js, and Node.js).",
    },
    {
      id: "mern-003",
      title: "Node.js Backend Developer",
      company: "BackendMasters",
      location: "India, Remote",
      salary: "₹10L - ₹22L",
      description:
        "BackendMasters is looking for a Node.js Developer to design and maintain the server-side logic for our applications. If you are proficient with Node.js and Express.js, apply to work on backend systems that scale.",
    },
    {
      id: "mern-004",
      title: "React.js Frontend Developer",
      company: "ReactPros",
      location: "India, Remote",
      salary: "₹12L - ₹25L",
      description:
        "ReactPros is looking for a Frontend Developer with expertise in React.js. Join our team to build beautiful and responsive user interfaces for various web applications.",
    },
    {
      id: "mern-005",
      title: "Full Stack MERN Developer",
      company: "CodeCrafters",
      location: "India, Remote",
      salary: "₹14L - ₹28L",
      description:
        "CodeCrafters is hiring a Full Stack Developer proficient in the MERN stack. You will be involved in both frontend and backend development, creating seamless and efficient web applications.",
    },
    {
      id: "mern-006",
      title: "MERN Stack Architect",
      company: "VisionaryCoders",
      location: "India, Remote",
      salary: "₹18L - ₹35L",
      description:
        "VisionaryCoders is seeking a MERN Stack Architect to design and lead the development of complex web applications. This is a leadership role focused on ensuring scalability, performance, and maintainability.",
    },
    {
      id: "mern-007",
      title: "Node.js DevOps Engineer",
      company: "DevOpsMasters",
      location: "India, Remote",
      salary: "₹12L - ₹24L",
      description:
        "DevOpsMasters is looking for a Node.js DevOps Engineer to handle the deployment, scaling, and maintenance of Node.js applications. You will ensure smooth CI/CD processes and infrastructure scalability.",
    },
    {
      id: "mern-008",
      title: "Senior MERN Stack Security Engineer",
      company: "SecureStack",
      location: "India, Remote",
      salary: "₹20L - ₹38L",
      description: "SecureStack is seeking a Senior MERN Stack Security Engineer to implement and maintain security best practices across our web applications. Focus on application security, code review, and secure development practices."
    },
    {
      id: "mern-009",
      title: "MERN Performance Optimization Specialist",
      company: "OptimizeWeb",
      location: "India, Remote",
      salary: "₹16L - ₹32L",
      description: "OptimizeWeb needs a MERN Stack Performance Specialist to improve application speed and efficiency. Focus on optimizing React components, Node.js backend, and MongoDB queries."
    },
    {
      id: "mern-010",
      title: "Junior MERN Stack Developer",
      company: "TechStart",
      location: "India, Remote",
      salary: "₹8L - ₹15L",
      description: "TechStart is looking for passionate Junior MERN Stack Developers to join our growing team. Great opportunity for developers with 1-2 years of experience to grow and learn."
    },
    {
      id: "mern-011",
      title: "MERN Stack Team Lead",
      company: "LeadTech Solutions",
      location: "India, Remote",
      salary: "₹25L - ₹45L",
      description: "LeadTech Solutions requires a MERN Stack Team Lead to manage a team of developers and ensure project success. Strong leadership and technical skills required."
    },
    {
      id: "mern-012",
      title: "MERN Stack E-commerce Specialist",
      company: "EcomGenius",
      location: "India, Remote",
      salary: "₹14L - ₹28L",
      description: "EcomGenius is hiring a MERN Stack Developer with e-commerce expertise to build and maintain online shopping platforms using the MERN stack."
    },
    {
      id: "mern-013",
      title: "Full Stack MERN Developer (AI Focus)",
      company: "AITechLabs",
      location: "India, Remote",
      salary: "₹18L - ₹35L",
      description: "AITechLabs seeks a Full Stack MERN Developer with experience in AI/ML integration to build intelligent web applications."
    },
    {
      id: "mern-014",
      title: "MERN Stack Cloud Specialist",
      company: "CloudTechPro",
      location: "India, Remote",
      salary: "₹16L - ₹30L",
      description: "CloudTechPro is looking for a MERN Stack Developer with strong AWS/Cloud experience to build and deploy scalable cloud applications."
    },
    {
      id: "mern-015",
      title: "MERN Stack Mobile Developer",
      company: "MobileFirst",
      location: "India, Remote",
      salary: "₹15L - ₹28L",
      description: "MobileFirst needs a MERN Stack Developer with React Native experience to build cross-platform mobile applications."
    },
    {
      id: "mern-016",
      title: "MERN Stack Testing Specialist",
      company: "QualityTech",
      location: "India, Remote",
      salary: "₹14L - ₹26L",
      description: "QualityTech is hiring a MERN Stack Testing Specialist to implement comprehensive testing strategies for web applications."
    },
    {
      id: "mern-017",
      title: "MERN Stack UI/UX Developer",
      company: "DesignPro",
      location: "India, Remote",
      salary: "₹16L - ₹30L",
      description: "DesignPro seeks a MERN Stack Developer with strong UI/UX skills to create beautiful and functional web applications."
    },
    {
      id: "mern-018",
      title: "Senior MERN Stack Consultant",
      company: "TechConsult",
      location: "India, Remote",
      salary: "₹28L - ₹45L",
      description: "TechConsult is looking for a Senior MERN Stack Consultant to provide technical leadership and consulting services to our clients."
    },
    {
      id: "mern-019",
      title: "MERN Stack API Specialist",
      company: "APITech",
      location: "India, Remote",
      salary: "₹15L - ₹28L",
      description: "APITech needs a MERN Stack Developer specialized in designing and implementing RESTful APIs and microservices."
    },
    {
      id: "mern-020",
      title: "MERN Stack Data Visualization Expert",
      company: "DataViz",
      location: "India, Remote",
      salary: "₹17L - ₹32L",
      description: "DataViz is seeking a MERN Stack Developer with expertise in data visualization libraries to create interactive dashboards."
    },
    {
      id: "mern-021",
      title: "MERN Stack Blockchain Developer",
      company: "BlockchainTech",
      location: "India, Remote",
      salary: "₹20L - ₹40L",
      description: "BlockchainTech is looking for a MERN Stack Developer with blockchain integration experience to build decentralized applications."
    },
    {
      id: "mern-022",
      title: "MERN Stack GraphQL Specialist",
      company: "GraphQLPro",
      location: "India, Remote",
      salary: "₹16L - ₹30L",
      description: "GraphQLPro seeks a MERN Stack Developer with strong GraphQL experience to build efficient API-driven applications."
    },
    {
      id: "mern-023",
      title: "MERN Stack Real-time Applications Developer",
      company: "RealTimeTech",
      location: "India, Remote",
      salary: "₹15L - ₹29L",
      description: "RealTimeTech is hiring a MERN Stack Developer to build real-time applications using WebSocket and Socket.io."
    },
    {
      id: "mern-024",
      title: "MERN Stack CMS Developer",
      company: "CMSolutions",
      location: "India, Remote",
      salary: "₹14L - ₹27L",
      description: "CMSolutions needs a MERN Stack Developer to build and maintain content management systems for various clients."
    },
    {
      id: "mern-025",
      title: "MERN Stack Training Lead",
      company: "TechTrainers",
      location: "India, Remote",
      salary: "₹22L - ₹40L",
      description: "TechTrainers is looking for a MERN Stack Training Lead to develop and deliver training programs for junior developers."
    },
    {
      id: "mern-026",
      title: "MERN Stack Documentation Specialist",
      company: "DocTech",
      location: "India, Remote",
      salary: "₹12L - ₹24L",
      description: "DocTech seeks a MERN Stack Developer with excellent documentation skills to create technical documentation and API guides."
    },
    {
      id: "mern-027",
      title: "MERN Stack Migration Specialist",
      company: "MigratePro",
      location: "India, Remote",
      salary: "₹18L - ₹35L",
      description: "MigratePro is hiring a MERN Stack Developer to lead legacy system migrations to modern MERN stack applications."
    },
    {
      id: "mern-028",
      title: "MERN Stack Intern",
      company: "CodeLaunch",
      location: "India, Remote",
      salary: "₹3L - ₹6L",
      description: "CodeLaunch is seeking MERN Stack Interns to assist in building web applications and gain hands-on industry experience."
    },
    {
      id: "mern-029",
      title: "Junior MERN Stack Developer",
      company: "StartUpLabs",
      location: "India, Remote",
      salary: "₹4L - ₹8L",
      description: "StartUpLabs is looking for a Junior MERN Stack Developer to work on exciting startup projects with mentorship from senior developers."
    },
    {
      id: "mern-030",
      title: "MERN Stack Trainee Engineer",
      company: "TechNest",
      location: "India, Remote",
      salary: "₹3.5L - ₹7L",
      description: "TechNest is hiring MERN Stack Trainees to participate in an intensive training program followed by real-world project development."
    },
    {
      id: "mern-031",
      title: "MERN Stack Development Intern",
      company: "InnoSoft",
      location: "India, Remote",
      salary: "₹3L - ₹5L",
      description: "InnoSoft is offering a MERN Stack Development Internship focusing on creating scalable web apps under expert guidance."
    },
    {
      id: "mern-032",
      title: "Frontend Intern (React.js) - MERN Stack",
      company: "BrightDevs",
      location: "India, Remote",
      salary: "₹2.5L - ₹4L",
      description: "BrightDevs is looking for a Frontend Intern specializing in React.js to join our MERN stack projects and boost their frontend skills."
    },
    {
      id: "mern-033",
      title: "Backend Intern (Node.js) - MERN Stack",
      company: "SkyNetics",
      location: "India, Remote",
      salary: "₹2.5L - ₹4.5L",
      description: "SkyNetics seeks a Node.js Intern to support backend development for MERN stack projects, focusing on API creation and optimization."
    },
    {
      id: "mern-034",
      title: "Junior Full Stack Developer (MERN)",
      company: "DevNest",
      location: "India, Remote",
      salary: "₹5L - ₹8L",
      description: "DevNest is hiring junior full stack developers to work on end-to-end MERN stack solutions for global clients."
    },
    {
      id: "mern-035",
      title: "React.js Developer Intern",
      company: "UIExperts",
      location: "India, Remote",
      salary: "₹2.8L - ₹4.5L",
      description: "UIExperts is looking for React.js Interns passionate about creating beautiful and performant user interfaces."
    },
    {
      id: "mern-036",
      title: "Node.js Developer Intern",
      company: "APIConnect",
      location: "India, Remote",
      salary: "₹3L - ₹5L",
      description: "APIConnect offers internships to freshers who want to build scalable Node.js backend systems for modern apps."
    },
    {
      id: "mern-037",
      title: "MongoDB Intern - MERN Stack",
      company: "DataStruct",
      location: "India, Remote",
      salary: "₹2.5L - ₹4L",
      description: "DataStruct is seeking MongoDB Interns to assist with database design, optimization, and backend integration in MERN projects."
    },
    {
      id: "mern-038",
      title: "Express.js Intern - MERN Projects",
      company: "RapidDevs",
      location: "India, Remote",
      salary: "₹2.5L - ₹4.5L",
      description: "RapidDevs is hiring Express.js Interns to contribute to building scalable backend services within the MERN ecosystem."
    },
    {
      id: "mern-039",
      title: "MERN Stack Support Intern",
      company: "HelpDesk Tech",
      location: "India, Remote",
      salary: "₹2.5L - ₹3.5L",
      description: "HelpDesk Tech needs MERN Stack Interns to support ongoing projects, perform testing, and handle technical documentation."
    },
    {
      id: "mern-040",
      title: "MERN Stack Quality Assurance Intern",
      company: "BugTrackers",
      location: "India, Remote",
      salary: "₹2.5L - ₹4L",
      description: "BugTrackers is seeking interns interested in testing, debugging, and improving the performance of MERN stack applications."
    },
    {
      id: "mern-041",
      title: "MERN Stack Research Intern",
      company: "InnovateLabs",
      location: "India, Remote",
      salary: "₹2.5L - ₹4L",
      description: "InnovateLabs offers a research internship to explore the latest trends and best practices in the MERN stack."
    },
    {
      id: "mern-042",
      title: "MERN Stack SEO Optimization Intern",
      company: "WebBoost",
      location: "India, Remote",
      salary: "₹3L - ₹5L",
      description: "WebBoost is hiring MERN developers with interest in SEO to optimize React apps for search engine visibility."
    },
    {
      id: "mern-043",
      title: "Junior Cloud Developer - MERN Stack",
      company: "CloudCrafter",
      location: "India, Remote",
      salary: "₹5L - ₹9L",
      description: "CloudCrafter is hiring junior developers to deploy and manage MERN stack applications on AWS and Azure."
    },
    {
      id: "mern-044",
      title: "Junior DevOps Engineer - MERN Focus",
      company: "DeployNow",
      location: "India, Remote",
      salary: "₹5L - ₹10L",
      description: "DeployNow is seeking junior DevOps Engineers who are familiar with MERN stack deployment pipelines and CI/CD setups."
    },
    {
      id: "mern-045",
      title: "Mobile App Intern (React Native + MERN)",
      company: "Mobitech",
      location: "India, Remote",
      salary: "₹3L - ₹5.5L",
      description: "Mobitech is offering a mobile development internship focused on integrating React Native apps with MERN backend systems."
    },
    {
      id: "mern-046",
      title: "Junior React.js Developer",
      company: "PixelWave",
      location: "India, Remote",
      salary: "₹4L - ₹7L",
      description: "PixelWave is looking for a Junior React.js Developer to work on UI-intensive web projects using the latest tech stack."
    },
    {
      id: "mern-047",
      title: "Node.js API Intern",
      company: "BackendLabs",
      location: "India, Remote",
      salary: "₹3L - ₹5L",
      description: "BackendLabs is offering a Node.js internship focused on building fast, reliable RESTful APIs for modern web apps."
    },
    {
      id: "mern-048",
      title: "Full Stack Web Development Intern (MERN)",
      company: "CodeCrush",
      location: "India, Remote",
      salary: "₹3.5L - ₹6L",
      description: "CodeCrush invites applications for its Full Stack MERN Internship Program to build scalable apps from scratch."
    },
    {
      id: "mern-049",
      title: "MERN Stack AI Integration Intern",
      company: "BrainFuse",
      location: "India, Remote",
      salary: "₹4L - ₹7L",
      description: "BrainFuse seeks MERN Stack Interns with a passion for AI and ML integrations into full-stack apps."
    },
    {
      id: "mern-050",
      title: "MERN Stack Chatbot Development Intern",
      company: "BotifyTech",
      location: "India, Remote",
      salary: "₹3.5L - ₹6.5L",
      description: "BotifyTech is hiring Interns to build smart chatbots using Node.js, Express, and AI APIs integrated with React."
    },
    {
      id: "mern-051",
      title: "Cloud Deployment Intern (AWS + MERN)",
      company: "CloudNest",
      location: "India, Remote",
      salary: "₹4L - ₹7L",
      description: "CloudNest is hiring interns with a focus on cloud deployment strategies for MERN stack applications using AWS."
    },
    {
      id: "mern-052",
      title: "GraphQL Development Intern - MERN",
      company: "QueryX",
      location: "India, Remote",
      salary: "₹3L - ₹5.5L",
      description: "QueryX seeks MERN developers who are interested in building GraphQL APIs for dynamic data fetching."
    },
    {
      id: "mern-053",
      title: "Junior Web Security Analyst (MERN)",
      company: "SecuWeb",
      location: "India, Remote",
      salary: "₹5L - ₹8L",
      description: "SecuWeb is offering a junior position focusing on securing MERN applications against vulnerabilities."
    },
    {
      id: "mern-054",
      title: "JAMstack Intern (Next.js + MERN Backend)",
      company: "JamCore",
      location: "India, Remote",
      salary: "₹3L - ₹5.5L",
      description: "JamCore seeks interns to explore JAMstack architecture, combining serverless backend (MERN) with static frontend."
    },
    {
      id: "mern-055",
      title: "Docker & MERN Stack Intern",
      company: "ContainerWave",
      location: "India, Remote",
      salary: "₹4L - ₹6.5L",
      description: "ContainerWave offers an internship to help containerize MERN apps using Docker and Kubernetes."
    },{
      id: "mern-056",
      title: "Junior MERN Stack Support Engineer",
      company: "AppSupportX",
      location: "India, Remote",
      salary: "₹3L - ₹5.5L",
      description: "AppSupportX is hiring junior engineers to troubleshoot, debug, and maintain MERN stack-based web applications."
    },
    {
      id: "mern-057",
      title: "React Native Mobile Intern",
      company: "MoveMobile",
      location: "India, Remote",
      salary: "₹3L - ₹6L",
      description: "MoveMobile is offering a mobile development internship for candidates skilled in React Native and Node.js backend."
    },
    {
      id: "mern-058",
      title: "Serverless Intern (MERN + AWS Lambda)",
      company: "LambdaLaunch",
      location: "India, Remote",
      salary: "₹4L - ₹7L",
      description: "LambdaLaunch is seeking interns interested in building serverless APIs with MERN and AWS Lambda."
    },
    {
      id: "mern-059",
      title: "Data Visualization Intern (MERN + D3.js)",
      company: "VizzyData",
      location: "India, Remote",
      salary: "₹3.5L - ₹6.5L",
      description: "VizzyData is hiring MERN stack interns skilled in data visualization using D3.js and React.js."
    },
    {
      id: "mern-060",
      title: "MERN Stack E-commerce Intern",
      company: "ShopSphere",
      location: "India, Remote",
      salary: "₹3L - ₹6L",
      description: "ShopSphere seeks interns to develop scalable MERN-based e-commerce platforms and real-time payment integrations."
    },
    {
      id: "mern-061",
      title: "Junior Microservices Developer (Node.js)",
      company: "MicroCore",
      location: "India, Remote",
      salary: "₹4L - ₹7L",
      description: "MicroCore is looking for junior developers to build microservices architecture using Node.js and Express.js."
    },
    {
      id: "mern-062",
      title: "MERN Stack DevTools Intern",
      company: "DevKit Labs",
      location: "India, Remote",
      salary: "₹2.8L - ₹5L",
      description: "DevKit Labs invites interns to build productivity tools and dev utilities around the MERN stack."
    },
    {
      id: "mern-063",
      title: "Web3 Developer Intern (MERN + Blockchain)",
      company: "ChainFusion",
      location: "India, Remote",
      salary: "₹5L - ₹8L",
      description: "ChainFusion is hiring interns to integrate MERN apps with Ethereum smart contracts and Web3.js libraries."
    },
    {
      id: "mern-064",
      title: "Junior UI/UX Engineer (React.js)",
      company: "DesignNest",
      location: "India, Remote",
      salary: "₹3.5L - ₹6.5L",
      description: "DesignNest is seeking junior UI/UX engineers to create beautiful, responsive interfaces using React.js."
    },
    {
      id: "mern-065",
      title: "Next.js + MERN Stack Intern",
      company: "NextGenCoders",
      location: "India, Remote",
      salary: "₹3.5L - ₹6L",
      description: "NextGenCoders is offering internships combining Next.js frontend development with Node.js backend APIs."
    },
    {
      id: "mern-066",
      title: "MERN Stack Project Management Intern",
      company: "TaskFlow",
      location: "India, Remote",
      salary: "₹2.5L - ₹4L",
      description: "TaskFlow is hiring interns to assist in project tracking, task assignments, and project documentation for MERN teams."
    },
    {
      id: "mern-067",
      title: "MERN Stack Analytics Intern",
      company: "MetricMinds",
      location: "India, Remote",
      salary: "₹3.5L - ₹6L",
      description: "MetricMinds seeks interns to work on analytics dashboards integrated into MERN web applications."
    },
    {
      id: "mern-068",
      title: "Junior Automation QA Engineer (MERN)",
      company: "AutoTest",
      location: "India, Remote",
      salary: "₹4L - ₹7L",
      description: "AutoTest is hiring junior QA engineers to automate testing for MERN stack apps using Selenium and Cypress."
    },
    {
      id: "mern-069",
      title: "MERN Stack CMS Intern",
      company: "ContentCloud",
      location: "India, Remote",
      salary: "₹3L - ₹5.5L",
      description: "ContentCloud invites applications for interns helping to develop CMS platforms using MERN technologies."
    },
    {
      id: "mern-070",
      title: "Junior Firebase Developer (MERN)",
      company: "FireStarter",
      location: "India, Remote",
      salary: "₹4L - ₹7.5L",
      description: "FireStarter is hiring junior developers to integrate Firebase services (Auth, Firestore) into MERN stack apps."
    }
    
   
    
  ];

  return (
    <>
      <Helmet>
        <title>MERN Stack Developer Jobs 2025 | Remote Jobs in India</title>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Find high-paying remote MERN stack developer jobs in India. Salaries from ₹10L to ₹35L per annum. Jobs at top companies like Techlight, InnoTechies, and more. Apply now!"
        />
        <meta
          name="keywords"
          content="MERN stack jobs, MongoDB jobs, Express.js jobs, React.js jobs, Node.js jobs, remote developer jobs, India IT jobs, web development jobs, full stack developer, javascript jobs, remote work, developer jobs 2025"
        />
        <meta name="author" content="Only Remote Jobs" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="MERN Stack Developer Jobs 2025 | Remote Jobs in India" />
        <meta property="og:description" content="Find high-paying remote MERN stack developer jobs in India. Salaries from ₹10L to ₹35L per annum." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://yourwebsite.com/mern-stack-jobs" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "JobPosting",
              "title": "MERN Stack Developer Jobs",
              "description": "Remote MERN stack developer positions across India",
              "industry": "Information Technology",
              "employmentType": "FULL_TIME",
              "datePosted": "${new Date().toISOString()}",
              "validThrough": "${new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString()}",
              "jobLocationType": "TELECOMMUTE",
              "baseSalary": {
                "@type": "MonetaryAmount",
                "currency": "INR",
                "value": {
                  "@type": "QuantitativeValue",
                  "minValue": 1000000,
                  "maxValue": 3500000,
                  "unitText": "YEAR"
                }
              }
            }
          `}
        </script>
      </Helmet>
      <Header />
      <main>
        <div className="container mt-4">
          <div className="row">
            <div className="col-md-12 mb-12 text-center">
              <h1 className="font-weight-bold">MERN Stack Developer Jobs 2025</h1>
              <p className="lead">
                Explore high-paying remote opportunities in MERN stack development. 
                Salaries ranging from ₹10L to ₹35L per annum.
              </p>
            </div>
            <section className="job-listings col-12">
              {jobOpenings.map((job) => (
                <article key={job.id} className="col-md-12 mb-12">
                  <Card>
                    <Card.Body>
                      <h2 className="h5"><Card.Title>{job.title}</Card.Title></h2>
                      <Card.Text>
                        <strong>Salary:</strong> {job.salary}
                      </Card.Text>
                      <Card.Subtitle className="mb-12 text-muted">
                        <strong>Company:</strong> {job.company} - {job.location}
                      </Card.Subtitle>
                      <Card.Text>
                        <strong>Job Description:</strong><br/>
                        {job.description}
                      </Card.Text>
                      <div className="d-flex justify-content-between align-items-center">
                        <Button 
                          variant="primary" 
                          onClick={() => handleApplyNow(job)}
                          aria-label={`Apply for ${job.title} at ${job.company}`}
                        >
                          Apply Now
                        </Button>
                        <time dateTime={new Date().toISOString()}>Posted Today</time>
                      </div>
                    </Card.Body>
                  </Card>
                  <br />
                </article>
              ))}
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}